import { useCallback, useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { checkActive } from '@/api/query/customer';

const PLAN_GATE_POLL_MS = 5000;

export const useAccountPlanGate = (enabled) => {
	const [isAccountActive, setIsAccountActive] = useState(null);

	const checkActiveMutation = useMutation({
		mutationFn: () => checkActive(),
		onSuccess: ({ data }) => {
			setIsAccountActive(data.isActive);
		},
		onError: () => {
			setIsAccountActive(false);
		},
	});

	const refreshAccountStatus = useCallback(() => {
		if (!enabled) {
			setIsAccountActive(null);
			return;
		}

		checkActiveMutation.mutate();
	}, [enabled, checkActiveMutation.mutate]);

	useEffect(() => {
		if (!enabled) {
			setIsAccountActive(null);
			return undefined;
		}

		checkActiveMutation.mutate();
	}, [enabled, checkActiveMutation.mutate]);

	useEffect(() => {
		if (!enabled || isAccountActive !== false) {
			return undefined;
		}

		const interval = window.setInterval(() => {
			checkActiveMutation.mutate();
		}, PLAN_GATE_POLL_MS);

		return () => window.clearInterval(interval);
	}, [enabled, isAccountActive, checkActiveMutation.mutate]);

	const isAccountChecking =
		enabled && isAccountActive === null && checkActiveMutation.isPending;

	return {
		isAccountActive,
		isAccountChecking,
		needsPlan: enabled && isAccountActive === false,
		refreshAccountStatus,
	};
};
